import CommonCheckBoxField from "./CommonCheckBoxField";

export default CommonCheckBoxField;
